import {storyblokEditable, useStoryblokApi} from "@storyblok/react";
import classNames from "classnames";
import ButtonGroup from "../partials/ButtonGroup";
import {richTextResolver} from "@storyblok/richtext";

export default function ContentSection(props: { blok: any }) {

    const blok = props.blok;
    const buttons = <ButtonGroup buttons={blok.buttons}/>
    const { render } = richTextResolver()
    return (
        <div className={"overflow-hidden " + blok.class} {...storyblokEditable(blok)}>
            <div className={"mx-auto space-y-8 px-4 sm:px-6 lg:px-8 " + blok?.container_size}>
                <div className="">
                    <div className={classNames({"relative z-10": true, "col-span-2": !blok.show_quote})}>
                        <div className="mx-auto max-w-prose text-base lg:max-w-none">
                            <h2 className="text-lg font-semibold text-secondary">
                                {blok.subtitle}
                            </h2>
                            <p className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
                                {blok.title}
                            </p>
                        </div>
                        <div className="relative z-10 mx-auto max-w-prose text-base lg:mx-0 lg:max-w-5xl lg:pr-72">
                            <p className="mt-2 text-lg text-gray-500">
                                {blok.intro}
                            </p>
                        </div>

                        <div className="prose prose-secondary mx-auto text-gray-500 lg:max-w-none ">
                            <div className=""
                                 dangerouslySetInnerHTML={{
                                     __html: render(blok.text) as string
                                 }}
                            >
                            </div>
                        </div>
                        <div className="mx-auto mt-10 flex max-w-prose text-base lg:max-w-none gap-4">
                            {buttons}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
